import { Badge } from '@heidi/design-system/badge';
import { useTranslations } from '@heidi/runtime/i18n';

import type { JSX } from 'react';

/**
 * IntegrationPartnerBadge - Consistent badge for integration partner sources (EVI-678)
 *
 * Used in both ReferenceCard and SourceCard to indicate that a citation
 * comes from an integration partner (e.g., DynaMed).
 */
export function IntegrationPartnerBadge(): JSX.Element {
  const { t } = useTranslations();

  return (
    <Badge color="proTier" size="sm" data-testid="integration-partner-badge">
      {t('integrationPartners.sourceLabels.clinicalResource')}
    </Badge>
  );
}
